import { jsx as _jsx } from "react/jsx-runtime";
import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { productBasedOfferIdsWithMandatorySkuSelector } from 'pricing-pages-ui/selectors/ProductBasedOffersSelectors';
import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { suitePurchaseMotionsMapSelector } from 'pricing-pages-ui/selectors/PurchaseMotionSelectors';
import { useSelector } from 'react-redux';
import { useQueryParamTerm } from '../../utils/urls/queryParamUtils';
import LoadingMerchCardAuthedCTAs from './LoadingMerchCardAuthedCTAs';
import LoadingMerchCardPublicCTAs from './LoadingMerchCardPublicCTAs';
import { useSuiteTileAuthedCTAsProps } from './useSuiteTileAuthedCTAsProps';

const SuiteTileCTAsContainer = props => {
  const {
    sourceId,
    productLevel,
    hubsSignupProductOverride,
    ctaStyles = {},
    trackingSource,
    isStarterGWPCard = false,
    returnFirstCTAOnly = false,
    isFreeToStarter
  } = props;
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const productBasedOfferIds = useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
    skuIds: checkoutProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const suitePurchaseMotions = useSelector(state => {
    const purchaseMotionsMap = suitePurchaseMotionsMapSelector(state);

    if (!Object.keys(purchaseMotionsMap).length) {
      return [];
    }

    return purchaseMotionsMap[productLevel];
  });
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import(
    /* webpackChunkName: "authed-chunk" */
    `pricing-pages-ui/components/merch-card/SuiteTileAuthedCTAs`),
    publicComponentLoader: () => import(
    /* webpackChunkName: "public-chunk" */
    `pricing-pages-ui/components/common/purchaseMotions/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, props, {
      isStarterGWPCard
    }),
    publicComponentProps: {
      use: 'primary',
      productConfigurations: checkoutProductConfigurations,
      purchaseMotions: isStarterGWPCard ? ['buyTouchless'] : returnFirstCTAOnly ? suitePurchaseMotions[0] : suitePurchaseMotions,
      productBasedOfferIds,
      sourceId: sourceId || 'pricing-hero',
      dtbSource: `pricing-page|growthsuite|${productLevel.toLowerCase()}`,
      numPurchaseMotions: 1,
      maxNumPurchaseMotions: 1,
      queryParamTerm,
      hubsSignupProductOverride,
      style: ctaStyles,
      trackingSource,
      isFreeToStarter
    },
    publicComponentLoadingState: LoadingMerchCardPublicCTAs,
    authedComponentLoadingState: LoadingMerchCardAuthedCTAs,
    useCommonAuthedProps: useSuiteTileAuthedCTAsProps,
    useCommonPublicProps: publicProps => publicProps
  });
};

export default SuiteTileCTAsContainer;